import React, { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'
import { useNavigate } from 'react-router-dom'

const RES_STYLES = `
  .res-hero { background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; border-radius:16px; padding:32px 28px; margin-bottom:24px; position:relative; overflow:hidden; }
  .res-hero::before { content:''; position:absolute; top:-50%; right:-10%; width:400px; height:400px; background:radial-gradient(circle,rgba(77,78,141,0.12),transparent 70%); pointer-events:none; }
  .res-hero-title { font-family:'Plus Jakarta Sans',sans-serif; font-size:30px; font-weight:600; color:#fff; margin:0 0 8px; letter-spacing:0.02em; }
  .res-hero-sub { font-size:13px; color:rgba(255,255,255,0.7); margin:0; line-height:1.6; }
  .res-tabs { display:flex; gap:0; border-bottom:2px solid #E2E4E7; margin-bottom:20px; flex-wrap:wrap; }
  .res-tab { padding:10px 16px; font-size:12px; font-weight:600; cursor:pointer; border:none; background:none; color:#5C6065; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.15s; font-family:inherit; white-space:nowrap; }
  .res-tab:hover { color:#151715; }
  .res-tab.active { color:#151715; border-bottom-color:#4D4E8D; }
  .res-section { background:#fff; border:1px solid #E2E4E7; border-radius:14px; overflow:hidden; margin-bottom:16px; }
  .res-section-header { padding:14px 20px; background:linear-gradient(135deg,#F5F6F7,#EEEFF1); border-bottom:1px solid #E2E4E7; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px; }
  .res-section-title { font-size:13px; font-weight:600; color:#151715; letter-spacing:0.04em; }
  .res-filter-row { display:flex; gap:8px; padding:12px 16px; border-bottom:1px solid #E2E4E7; flex-wrap:wrap; }
  .res-filter-btn { padding:5px 14px; border-radius:20px; font-size:11px; font-weight:600; border:1.5px solid #D7DADE; background:#fff; color:#5C6065; cursor:pointer; transition:all 0.15s; font-family:inherit; white-space:nowrap; }
  .res-filter-btn.active { background:#151715; color:#4D4E8D; border-color:#151715; }
  .res-filter-btn:hover { border-color:#4D4E8D; color:#151715; }
  .res-glossary-item { padding:14px 20px; border-bottom:1px solid #EEEFF1; }
  .res-glossary-item:last-child { border-bottom:none; }
  .res-glossary-item:hover { background:#F7F8F9; }
  .res-glossary-term { font-family:'Plus Jakarta Sans',sans-serif; font-size:17px; font-weight:600; color:#151715; margin-bottom:4px; }
  .res-glossary-def { font-size:13px; color:#3A3D40; line-height:1.7; }
  .res-glossary-cat { font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; background:#EEF2FF; color:#4B5EAA; margin-left:8px; }
  .res-chapter { border:1px solid #E2E4E7; border-radius:10px; overflow:hidden; margin-bottom:10px; }
  .res-chapter-btn { width:100%; display:flex; align-items:center; justify-content:space-between; padding:14px 18px; background:#F5F6F7; border:none; cursor:pointer; text-align:left; transition:background 0.15s; gap:12px; }
  .res-chapter-btn:hover { background:#EEEFF1; }
  .res-chapter-btn.completed { background:linear-gradient(135deg,#EAF2EE,#F0FAF4); }
  .res-chapter-num { font-size:10px; font-weight:700; color:#4D4E8D; letter-spacing:0.08em; margin-bottom:2px; }
  .res-chapter-title { font-family:'Plus Jakarta Sans',sans-serif; font-size:17px; font-weight:600; color:#151715; }
  .res-chapter-content { padding:18px 20px; font-size:13px; line-height:1.85; color:#3A3D40; white-space:pre-line; border-top:1px solid #E2E4E7; background:#fff; }
  .res-progress-bar-wrap { background:#E2E4E7; border-radius:99px; height:10px; overflow:hidden; flex:1; }
  .res-progress-bar-fill { height:100%; border-radius:99px; background:linear-gradient(90deg,#4D4E8D,#6E70AE); transition:width 0.4s ease; }
  .res-check { width:24px; height:24px; border-radius:50%; border:2px solid #4D4E8D; display:flex; align-items:center; justify-content:center; font-size:12px; flex-shrink:0; }
  .res-check.done { background:#4D4E8D; border-color:#4D4E8D; color:#fff; }
  .res-mark-btn { padding:8px 18px; border-radius:8px; border:none; cursor:pointer; font-size:12px; font-weight:600; font-family:inherit; transition:all 0.15s; }
  .res-mark-btn.done { background:#EAF2EE; color:#5E8A72; }
  .res-mark-btn.undone { background:linear-gradient(135deg,#4D4E8D,#41427a); color:#4D4E8D; }
  .res-cert-banner { background:linear-gradient(135deg,#4D4E8D,#41427a); border-radius:14px; padding:28px; text-align:center; margin-bottom:20px; border:2px solid #4D4E8D; }
  .res-state-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:10px; padding:16px; align-items:start; }
  .res-state-card { border:1px solid #E2E4E7; border-radius:10px; padding:14px 16px; background:#fff; transition:all 0.2s; cursor:pointer; }
  .res-state-card:hover { border-color:#4D4E8D; box-shadow:0 4px 12px rgba(77,78,141,0.1); transform:translateY(-1px); }
  .res-state-card.has-data { border-left:4px solid #4D4E8D; }
  .res-state-card-head { display:flex; align-items:center; gap:10px; }
  .res-state-code { width:36px; height:36px; border-radius:8px; background:linear-gradient(135deg,#4D4E8D,#41427a); display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; color:#4D4E8D; flex-shrink:0; }
  .res-state-name { font-size:13px; color:#151715; font-weight:600; line-height:1.3; flex:1; }
  .res-state-chip { font-size:9px; font-weight:700; padding:2px 7px; border-radius:10px; letter-spacing:0.04em; background:#EAF2EE; color:#5E8A72; border:1px solid #BBE5C8; }
  .res-state-link-btn { display:inline-flex; align-items:center; gap:5px; padding:6px 12px; border-radius:7px; font-size:11px; font-weight:600; text-decoration:none; background:#151715; color:#4D4E8D; border:none; cursor:pointer; font-family:inherit; }
  .res-state-link-btn:hover { background:#3A3D40; color:#6E70AE; text-decoration:none; }
  .res-state-link-btn.outline { background:#fff; color:#151715; border:1.5px solid #151715; }
  .res-state-link-btn.outline:hover { background:#EEEFF1; }

  /* STATE MODAL */
  .state-modal-overlay { position:fixed; inset:0; background:rgba(21,23,21,0.65); backdrop-filter:blur(4px); z-index:1000; display:flex; align-items:center; justify-content:center; padding:20px; animation:fadeIn 0.2s ease; }
  @keyframes fadeIn { from{opacity:0} to{opacity:1} }
  .state-modal { background:#fff; border-radius:18px; max-width:640px; width:100%; max-height:88vh; overflow:hidden; display:flex; flex-direction:column; box-shadow:0 20px 60px rgba(0,0,0,0.3); animation:slideUp 0.25s ease; }
  @keyframes slideUp { from{transform:translateY(20px);opacity:0} to{transform:translateY(0);opacity:1} }
  .state-modal-head { padding:20px 24px; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; display:flex; align-items:center; gap:14px; flex-shrink:0; }
  .state-modal-code { width:48px; height:48px; border-radius:10px; background:#4D4E8D; color:#fff; display:flex; align-items:center; justify-content:center; font-size:16px; font-weight:800; flex-shrink:0; }
  .state-modal-title { flex:1; }
  .state-modal-name { font-family:'Plus Jakarta Sans',sans-serif; font-size:24px; font-weight:600; color:#fff; line-height:1.2; }
  .state-modal-sub { font-size:11px; color:rgba(255,255,255,0.6); letter-spacing:0.06em; margin-top:2px; }
  .state-modal-close { background:rgba(255,255,255,0.1); border:none; color:#fff; width:34px; height:34px; border-radius:50%; cursor:pointer; font-size:18px; transition:background 0.15s; flex-shrink:0; }
  .state-modal-close:hover { background:rgba(255,255,255,0.2); }
  .state-modal-body { padding:20px 24px; overflow-y:auto; flex:1; }
  .state-modal-field { display:flex; gap:14px; padding:12px 0; border-bottom:1px solid #EEEFF1; align-items:flex-start; }
  .state-modal-field:last-child { border-bottom:none; }
  .state-modal-field-label { font-weight:700; color:#5C6065; min-width:170px; font-size:12px; letter-spacing:0.03em; flex-shrink:0; }
  .state-modal-field-value { color:#151715; flex:1; font-size:14px; line-height:1.6; white-space:pre-line; }
  .state-modal-foot { padding:16px 24px; border-top:1px solid #E2E4E7; display:flex; gap:10px; flex-wrap:wrap; justify-content:flex-end; background:#F7F8F9; flex-shrink:0; }
  .state-modal-disclaimer { padding:12px 24px; background:#EEF0F8; border-top:1px solid #F0D78A; font-size:11px; color:#41427a; line-height:1.5; display:flex; gap:8px; align-items:flex-start; flex-shrink:0; }
  .state-modal-disclaimer-icon { font-size:14px; flex-shrink:0; }
  .state-modal-empty { text-align:center; padding:40px 20px; color:#A2A6AA; font-size:13px; }

  /* GLOSSARY MODAL + COLLAPSIBLE LETTERS — same family as state-modal!! */
  .glossary-term-card { padding:14px 20px; border-bottom:1px solid #EEEFF1; cursor:pointer; transition:background 0.15s; }
  .glossary-term-card:last-child { border-bottom:none; }
  .glossary-term-card:hover { background:#EEF0F8; }
  .glossary-modal-icon { width:48px; height:48px; border-radius:10px; background:#4D4E8D; color:#fff; display:flex; align-items:center; justify-content:center; font-size:24px; font-weight:800; flex-shrink:0; }
  .glossary-modal-def { color:#151715; font-size:15px; line-height:1.85; padding:8px 0; }
  .glossary-letter-header { background:linear-gradient(135deg,#4D4E8D,#41427a); color:#4D4E8D; padding:8px 20px; font-family:'Plus Jakarta Sans',sans-serif; font-size:18px; font-weight:600; letter-spacing:0.06em; border-bottom:1px solid #E2E4E7; cursor:pointer; display:flex; align-items:center; justify-content:space-between; transition:background 0.15s; user-select:none; }
  .glossary-letter-header:hover { background:linear-gradient(135deg,#41427a,#4D4E8D); }
  .glossary-letter-chevron { font-size:14px; transition:transform 0.2s; }
  .glossary-letter-chevron.collapsed { transform:rotate(-90deg); }
  .glossary-letter-count { font-size:11px; color:rgba(77,78,141,0.6); font-weight:500; margin-left:8px; letter-spacing:0.04em; }

  .res-empty { text-align:center; padding:40px 20px; color:#A2A6AA; }
  .res-empty-icon { font-size:40px; margin-bottom:12px; opacity:0.6; }
  .res-empty-text { font-size:13px; color:#5C6065; max-width:400px; margin:0 auto; line-height:1.6; }
  .res-search { width:100%; padding:10px 14px; border:1.5px solid #D7DADE; border-radius:8px; font-size:13px; font-family:inherit; box-sizing:border-box; }
  .res-search:focus { outline:none; border-color:#4D4E8D; }
  .res-doc-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(240px,1fr)); gap:14px; padding:16px; }
  .res-doc-card { border:1px solid #E2E4E7; border-radius:12px; overflow:hidden; transition:all 0.2s; background:#fff; }
  .res-doc-card:hover { border-color:#4D4E8D; box-shadow:0 4px 16px rgba(77,78,141,0.1); transform:translateY(-2px); }
  .res-doc-card-top { padding:18px 16px; display:flex; align-items:center; gap:12px; border-bottom:1px solid #EEEFF1; }
  .res-doc-icon { width:44px; height:44px; border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0; background:#EEEFF1; }
  .res-doc-name { font-size:13px; font-weight:600; color:#151715; line-height:1.4; margin-bottom:3px; }
  .res-doc-desc { font-size:11px; color:#5C6065; line-height:1.5; }
  .res-doc-card-bottom { padding:10px 16px; display:flex; align-items:center; justify-content:space-between; gap:8px; }
  .res-doc-cat { font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; background:#EEEFF1; color:#5C6065; }
  .res-doc-btn { display:inline-flex; align-items:center; gap:6px; padding:6px 14px; border-radius:8px; font-size:11px; font-weight:600; text-decoration:none; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#4D4E8D; border:none; cursor:pointer; transition:all 0.15s; font-family:inherit; }
  .res-doc-btn:hover { background:linear-gradient(135deg,#41427a,#4D4E8D); text-decoration:none; color:#6E70AE; }

  /* CERTIFICATE */
  .cert-overlay { position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.7); z-index:1000; display:flex; align-items:center; justify-content:center; padding:20px; }
  .cert-modal { background:#fff; border-radius:20px; max-width:680px; width:100%; max-height:90vh; overflow-y:auto; }
  .cert-paper { background:linear-gradient(135deg,#FFFDF5,#FFF8E7); border:3px solid #4D4E8D; border-radius:16px; padding:40px 36px; text-align:center; position:relative; }
  .cert-paper::before { content:''; position:absolute; inset:8px; border:1px solid rgba(77,78,141,0.3); border-radius:12px; pointer-events:none; }
  .cert-header { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; letter-spacing:0.2em; color:#41427a; text-transform:uppercase; margin-bottom:8px; }
  .cert-title { font-family:'Plus Jakarta Sans',sans-serif; font-size:36px; font-weight:700; color:#151715; margin-bottom:4px; line-height:1.2; }
  .cert-subtitle { font-family:'Plus Jakarta Sans',sans-serif; font-size:18px; color:#41427a; margin-bottom:24px; }
  .cert-body { font-size:13px; color:#3A3D40; line-height:1.8; margin-bottom:20px; }
  .cert-name { font-family:'Plus Jakarta Sans',sans-serif; font-size:32px; font-weight:600; color:#151715; border-bottom:2px solid #4D4E8D; display:inline-block; padding-bottom:4px; margin:8px 0 20px; }
  .cert-seal { width:80px; height:80px; margin:0 auto 16px; }
  .cert-date { font-size:11px; color:#41427a; letter-spacing:0.08em; margin-top:16px; }
  .cert-close-btn { margin-top:20px; padding:12px 32px; border-radius:10px; border:none; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#4D4E8D; cursor:pointer; font-size:13px; font-weight:600; font-family:inherit; }
`

const GLOSSARY_CATEGORIES = ['All','Notary Fundamentals','Notarial Certificates','Signing Agent Terms','Mortgage & Loan Terms','Real Estate Terms','Apostille & Authentication Terms','Estate Planning Terms','Identity & Business Terms','General']
const DOC_CATEGORIES = ['All','Notarial Certificates','Loan Signing Documents','Study Guides','Notary Business','Miscellaneous']

// State data fields shown when expanded
const STATE_FIELDS = [
  { key:'max_notary_fee',      label:'💰 Max Notary Fee' },
  { key:'ron_status',           label:'🖥️ RON Status' },
  { key:'journal_required',     label:'📓 Journal Required' },
  { key:'attorney_closing',     label:'⚖️ Attorney Closing' },
  { key:'travel_fee_guidance',  label:'🚗 Travel Fee' },
  { key:'bond_requirements',    label:'📜 E&O or Bond' },
  { key:'commission_term',      label:'⏰ Commission Term' },
  { key:'wedding_ceremonies',   label:'💍 Wedding Ceremonies' },
  { key:'special_notes',        label:'📝 Special Notes' },
]

// Helper: does this state have ANY of the regulation fields filled?
function stateHasData(s) {
  return STATE_FIELDS.some(f => s[f.key] && String(s[f.key]).trim())
}

// ── TRAINING MANUAL REDIRECT ─────────────────────────────────
// The Training Manual now lives in the Notary Academy as a track.
// This section either:
//   - Welcomes the notary and links them to the Academy
//   - OR (if they already completed it in the OLD system) shows a
//     warm acknowledgement with their cert print + an Academy link
function TrainingManualRedirect() {
  const navigate = useNavigate()
  const [loading,     setLoading]     = useState(true)
  const [hadCompleted, setHadCompleted] = useState(false)
  const [notaryName,   setNotaryName]   = useState('')
  const [certIssuedAt, setCertIssuedAt] = useState(null)
  const [showCert,     setShowCert]     = useState(false)
  const [totalChapters, setTotalChapters] = useState(13)

  useEffect(() => {
    async function init() {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) { setLoading(false); return }

      // Get notary name
      const { data: profile } = await supabase.from('profiles').select('full_name').eq('id', user.id).single()
      if (profile) setNotaryName(profile.full_name || '')

      // How many published chapters does the OLD system have?
      const { count: totalCount } = await supabase
        .from('resources_chapters')
        .select('*', { count: 'exact', head: true })
        .eq('published', true)
      if (totalCount) setTotalChapters(totalCount)

      // Check if this user finished ALL chapters in the old manual_progress
      const { data: progress } = await supabase
        .from('manual_progress')
        .select('chapter_id, completed_at')
        .eq('notary_id', user.id)
        .order('completed_at', { ascending: false })

      const completedCount = (progress || []).length
      if (totalCount && completedCount >= totalCount) {
        setHadCompleted(true)
        if (progress && progress[0]) setCertIssuedAt(progress[0].completed_at)
      }
      setLoading(false)
    }
    init()
  }, [])

  function goToAcademy() {
    navigate('/notary/academy')
  }

  function printCertificate() {
    const issued = certIssuedAt ? new Date(certIssuedAt).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}) + ' · ' + new Date(certIssuedAt).toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit'}) : '—'
    const name = notaryName
    const w = window.open('', '_blank')
    w.document.write(`<!DOCTYPE html><html><head><title>NSV Training Certificate</title><style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{background:#FFFDF5;display:flex;align-items:center;justify-content:center;min-height:100vh;font-family:Georgia,serif;}
      .cert{background:linear-gradient(135deg,#FFFDF5,#FFF8E7);border:3px solid #4D4E8D;border-radius:16px;padding:50px 60px;text-align:center;max-width:720px;width:100%;position:relative;}
      .cert::before{content:'';position:absolute;inset:10px;border:1px solid rgba(77,78,141,0.3);border-radius:12px;}
      .badge{width:100px;height:100px;object-fit:contain;margin-bottom:16px;}
      .co-name{font-size:12px;letter-spacing:0.18em;color:#41427a;text-transform:uppercase;margin-bottom:4px;}
      .title{font-size:38px;font-weight:700;color:#151715;margin:12px 0 4px;}
      .subtitle{font-size:18px;color:#41427a;margin-bottom:24px;}
      .body{font-size:13px;color:#3A3D40;line-height:1.8;}
      .name{font-size:34px;font-weight:600;color:#151715;border-bottom:2px solid #4D4E8D;display:inline-block;padding-bottom:4px;margin:12px 0 20px;}
      .sig-img{height:70px;display:block;margin:0 auto -20px;position:relative;z-index:2;}
      .sigs{display:flex;justify-content:center;gap:80px;margin-top:36px;align-items:flex-end;}
      .sig-label{font-size:11px;font-weight:700;color:#41427a;letter-spacing:0.1em;border-top:2px solid #4D4E8D;padding-top:8px;}
      .sig-no-line{font-size:11px;font-weight:700;color:#41427a;letter-spacing:0.1em;padding-top:8px;}
      .sig-sub{font-size:10px;color:#A2A6AA;margin-top:3px;}
      @media print{body{background:#FFFDF5;}@page{margin:0.5in;size:landscape;}}
    </style></head><body>
    <div class="cert">
      <img class="badge" src="/lca_education_logo.png" alt="NSV Education Badge" />
      <div class="co-name" style="font-size:14px;letter-spacing:0.14em;">Notary Signing Vault, LLC.</div>
      <div class="co-name" style="font-size:11px;letter-spacing:0.1em;">DBA Nationwide Notary Professionals Network</div>
      <div class="title">Certificate of Completion</div>
      <div class="subtitle">NSV Training Manual</div>
      <div class="body">This certifies that</div>
      <div class="name">${name}</div>
      <div class="body">has successfully completed all chapters of the<br><strong>NSV Notary Professional Training Manual</strong><br>and demonstrated a commitment to excellence, integrity,<br>and the NSV standard of professionalism.</div>
      <div class="sigs">
        <div><img class="sig-img" src="/electronic_signature.png" alt="Nancy Phillips signature" /><div class="sig-label">NANCY PHILLIPS</div><div class="sig-sub">Chief Executive Officer & Founder</div><div class="sig-sub">Notary Signing Vault, LLC.</div></div>
        <div><div class="sig-no-line">DATE ISSUED</div><div class="sig-sub">${issued}</div></div>
      </div>
    </div>
    <script>window.onload=function(){window.print()}<\/script>
    </body></html>`)
    w.document.close()
  }

  if (loading) {
    return <div style={{ textAlign:'center', padding:40, color:'#A2A6AA', fontSize:13 }}>Loading...</div>
  }

  // ── PATH A: User had already completed the OLD Training Manual ──
  if (hadCompleted) {
    return (
      <>
        {/* CERTIFICATE PRINT MODAL (preserved from old system) */}
        {showCert && (
          <div className="cert-overlay" onClick={() => setShowCert(false)}>
            <div className="cert-modal" onClick={e => e.stopPropagation()}>
              <div id="lca-cert-print" className="cert-paper">
                <img src="/lca_education_logo.png" alt="NSV Education" style={{ width:100, height:100, objectFit:'contain', marginBottom:16 }} />
                <div className="cert-header" style={{ fontSize:14, letterSpacing:'0.16em' }}>Notary Signing Vault, LLC.</div>
                <div className="cert-header" style={{ marginBottom:20, fontSize:11 }}>DBA Nationwide Notary Professionals Network</div>
                <div className="cert-title">Certificate of Completion</div>
                <div className="cert-subtitle">NSV Training Manual</div>
                <div className="cert-body" style={{ marginTop:16 }}>This certifies that</div>
                <div className="cert-name">{notaryName}</div>
                <div className="cert-body">has successfully completed all chapters of the<br /><strong>NSV Notary Professional Training Manual</strong><br />and demonstrated a commitment to excellence, integrity,<br />and the NSV standard of professionalism.</div>
                <div style={{ display:'flex', justifyContent:'center', gap:60, marginTop:32, flexWrap:'wrap' }}>
                  <div style={{ textAlign:'center' }}>
                    <img src="/electronic_signature.png" alt="Nancy Phillips signature" style={{ height:60, display:'block', margin:'0 auto -16px', position:'relative', zIndex:2 }} />
                    <div style={{ borderTop:'2px solid #4D4E8D', paddingTop:8, fontSize:11, color:'#41427a', letterSpacing:'0.08em', fontWeight:600 }}>NANCY PHILLIPS</div>
                    <div style={{ fontSize:10, color:'#A2A6AA', marginTop:2 }}>Chief Executive Officer & Founder</div>
                    <div style={{ fontSize:10, color:'#A2A6AA', marginTop:1 }}>Notary Signing Vault, LLC.</div>
                  </div>
                  <div style={{ textAlign:'center', display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
                    <div style={{ fontSize:11, color:'#41427a', letterSpacing:'0.08em', fontWeight:600 }}>DATE ISSUED</div>
                    <div style={{ fontSize:10, color:'#A2A6AA', marginTop:2 }}>{certIssuedAt ? new Date(certIssuedAt).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}) + ' · ' + new Date(certIssuedAt).toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit'}) : '—'}</div>
                  </div>
                </div>
              </div>
              <div style={{ padding:'16px 24px', textAlign:'center', display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
                <button className="cert-close-btn" style={{ background:'#EEEFF1', color:'#151715', border:'1px solid #D7DADE' }} onClick={() => setShowCert(false)}>Close</button>
                <button className="cert-close-btn" onClick={printCertificate}>🖨️ Print Certificate</button>
              </div>
            </div>
          </div>
        )}

        {/* CONGRATS + REDIRECT BANNER FOR OLD COMPLETERS */}
        <div className="res-cert-banner">
          <div style={{ fontSize:48, marginBottom:12 }}>🏅</div>
          <div style={{ fontFamily:'Plus Jakarta Sans,sans-serif', fontSize:26, fontWeight:600, color:'#4D4E8D', marginBottom:8 }}>
            You've Completed the Training Manual!!
          </div>
          <div style={{ fontSize:13, color:'rgba(255,255,255,0.85)', marginBottom:6, lineHeight:1.6 }}>
            Thank you for completing all {totalChapters} chapters!!
          </div>
          <div style={{ fontSize:12, color:'rgba(255,255,255,0.7)', marginBottom:20, lineHeight:1.6 }}>
            Your certificate is preserved — and the Training Manual has now moved to the Notary Academy with progress tracking and a Certificate of Proficiency!!
          </div>
          <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
            <button onClick={() => setShowCert(true)} style={{ padding:'12px 24px', borderRadius:10, border:'2px solid #4D4E8D', background:'transparent', color:'#4D4E8D', cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'inherit' }}>
              🏅 View My Certificate
            </button>
            <button onClick={goToAcademy} style={{ padding:'12px 24px', borderRadius:10, border:'2px solid #4D4E8D', background:'#4D4E8D', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:'inherit' }}>
              🎓 Open Notary Academy →
            </button>
          </div>
        </div>

        {/* INFO STRIP — what's still in Resources */}
        <div style={{ background:'#F7F8F9', border:'1px solid #E2E4E7', borderRadius:12, padding:'18px 20px', textAlign:'center' }}>
          <div style={{ fontSize:13, color:'#151715', fontWeight:600, marginBottom:6 }}>
            📚 Resources still has everything you need:
          </div>
          <div style={{ fontSize:12, color:'#5C6065', lineHeight:1.7 }}>
            📖 Glossary of Terms · 🗺️ State Resources · 📂 Document Library
          </div>
        </div>
      </>
    )
  }

  // ── PATH B: New notary OR not-yet-completed — pure redirect ────
  return (
    <>
      <div style={{
        background: 'linear-gradient(135deg,#4D4E8D,#41427a)',
        borderRadius: 16,
        padding: '40px 32px',
        textAlign: 'center',
        marginBottom: 20,
        border: '2px solid #4D4E8D',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{ fontSize:60, marginBottom:16 }}>📋</div>
        <div style={{ fontFamily:'Plus Jakarta Sans,sans-serif', fontSize:30, fontWeight:600, color:'#4D4E8D', marginBottom:12 }}>
          The Training Manual Has Moved!!
        </div>
        <div style={{ fontSize:14, color:'rgba(255,255,255,0.85)', maxWidth:520, margin:'0 auto 8px', lineHeight:1.7 }}>
          Your <strong style={{ color:'#4D4E8D' }}>NSV Notary Professional Training Manual</strong> is now part of the Notary Academy — with progress tracking, lesson-by-lesson reading, and a Certificate of Proficiency when you complete it!!
        </div>
        <div style={{ fontSize:12, color:'rgba(255,255,255,0.65)', maxWidth:520, margin:'0 auto 24px', lineHeight:1.6, fontStyle:'italic' }}>
          Same content. Better experience. Plus your progress is now saved.
        </div>
        <button onClick={goToAcademy} style={{
          padding:'14px 32px',
          borderRadius:12,
          border:'2px solid #4D4E8D',
          background:'#4D4E8D', color:'#fff',
          cursor:'pointer',
          fontSize:14,
          fontWeight:700,
          fontFamily:'inherit',
          boxShadow:'0 4px 16px rgba(77,78,141,0.3)',
        }}>
          🎓 Open Notary Academy →
        </button>
      </div>

      {/* INFO STRIP — what's still in Resources */}
      <div style={{ background:'#F7F8F9', border:'1px solid #E2E4E7', borderRadius:12, padding:'18px 20px', textAlign:'center' }}>
        <div style={{ fontSize:13, color:'#151715', fontWeight:600, marginBottom:6 }}>
          📚 What's still here in Resources:
        </div>
        <div style={{ fontSize:12, color:'#5C6065', lineHeight:1.7 }}>
          📖 Glossary of Terms · 🗺️ State Resources · 📂 Document Library
        </div>
      </div>
    </>
  )
}

// ── GLOSSARY ──────────────────────────────────────────────────
function GlossarySection() {
  const [terms,     setTerms]     = useState([])
  const [loading,   setLoading]   = useState(true)
  const [search,    setSearch]    = useState('')
  const [filterCat, setFilterCat] = useState('All')
  const [modal,     setModal]     = useState(null)
  const [collapsedLetters, setCollapsedLetters] = useState(new Set())
  const [hasInitialized, setHasInitialized] = useState(false)

  useEffect(() => {
    supabase.from('resources_glossary').select('*').eq('published',true)
      .order('term',{ascending:true})
      .then(({ data }) => { setTerms(data||[]); setLoading(false) })
  }, [])

  // Close modal with Escape key
  useEffect(() => {
    if (!modal) return
    function onKey(e) { if (e.key === 'Escape') setModal(null) }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [modal])

  const filtered = terms.filter(t => {
    const matchCat    = filterCat==='All' || t.category===filterCat
    const matchSearch = !search || t.term.toLowerCase().includes(search.toLowerCase()) || t.definition.toLowerCase().includes(search.toLowerCase())
    return matchCat && matchSearch
  })

  if (loading) return <div style={{ textAlign:'center', padding:40, color:'#A2A6AA', fontSize:13 }}>Loading glossary...</div>

  return (
    <div className="res-section">
      <div className="res-section-header">
        <span className="res-section-title">📖 Glossary of Terms</span>
        <span style={{ fontSize:11, color:'#A2A6AA' }}>{terms.length} terms</span>
      </div>
      <div style={{ padding:'14px 20px', borderBottom:'1px solid #E2E4E7' }}>
        <input className="res-search" placeholder="Search glossary..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="res-filter-row">
        {GLOSSARY_CATEGORIES.map(c => (
          <button key={c} type="button" className={`res-filter-btn${filterCat===c?' active':''}`} onClick={() => setFilterCat(c)}>
            {c}{c!=='All'?` (${terms.filter(t=>t.category===c).length})`:''}
          </button>
        ))}
      </div>
      {filtered.length===0 ? (
        <div className="res-empty"><div className="res-empty-icon">🔍</div><div className="res-empty-text">{search?`No terms matching "${search}"`:'No terms in this category yet!!'}</div></div>
      ) : (
        (() => {
          // Group sorted terms by first letter for alphabetical sections
          const grouped = {}
          filtered.forEach(t => {
            const letter = t.term.charAt(0).toUpperCase()
            if (!grouped[letter]) grouped[letter] = []
            grouped[letter].push(t)
          })
          const letters = Object.keys(grouped).sort()
          // 🔒 On first render, collapse ALL letters by default!!
          if (!hasInitialized && letters.length > 0) {
            setCollapsedLetters(new Set(letters))
            setHasInitialized(true)
          }
          return letters.map(letter => {
            const isCollapsed = collapsedLetters.has(letter)
            const toggleLetter = () => {
              setCollapsedLetters(prev => {
                const n = new Set(prev)
                if (n.has(letter)) n.delete(letter)
                else n.add(letter)
                return n
              })
            }
            return (
              <div key={letter}>
                <div className="glossary-letter-header" onClick={toggleLetter} role="button" tabIndex={0} onKeyDown={e => e.key==='Enter' && toggleLetter()}>
                  <span>{letter}<span className="glossary-letter-count">({grouped[letter].length})</span></span>
                  <span className={`glossary-letter-chevron${isCollapsed?' collapsed':''}`}>▼</span>
                </div>
                {!isCollapsed && grouped[letter].map(t => (
                  <div key={t.id} className="glossary-term-card" onClick={() => setModal(t)} role="button" tabIndex={0} onKeyDown={e => e.key==='Enter' && setModal(t)}>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                          <span className="res-glossary-term">{t.term}</span>
                          {t.category && <span className="res-glossary-cat">{t.category}</span>}
                        </div>
                        <div style={{ fontSize:12, color:'#5C6065', marginTop:4, overflow:'hidden', textOverflow:'ellipsis', display:'-webkit-box', WebkitLineClamp:1, WebkitBoxOrient:'vertical' }}>
                          {t.definition}
                        </div>
                      </div>
                      <span style={{ fontSize:12, color:'#4D4E8D', fontWeight:600, flexShrink:0 }}>View →</span>
                    </div>
                  </div>
                ))}
              </div>
            )
          })
        })()
      )}

      {/* GLOSSARY TERM MODAL — matches State Resources style!! */}
      {modal && (
        <div className="state-modal-overlay" onClick={() => setModal(null)} role="dialog" aria-modal="true" aria-labelledby="glossary-modal-name">
          <div className="state-modal" onClick={e => e.stopPropagation()}>
            <div className="state-modal-head">
              <div className="glossary-modal-icon">📖</div>
              <div className="state-modal-title">
                <div id="glossary-modal-name" className="state-modal-name">{modal.term}</div>
                <div className="state-modal-sub">{modal.category || 'GLOSSARY TERM'}</div>
              </div>
              <button className="state-modal-close" onClick={() => setModal(null)} aria-label="Close">✕</button>
            </div>
            <div className="state-modal-body">
              <div className="glossary-modal-def">{modal.definition}</div>
            </div>
            <div className="state-modal-disclaimer">
              <span className="state-modal-disclaimer-icon">ℹ️</span>
              <span><em>Glossary definitions are for educational purposes. Always consult official state notary laws for your jurisdiction!!</em></span>
            </div>
            <div className="state-modal-foot">
              <button type="button" className="res-state-link-btn" style={{ background:'#5C6065' }} onClick={() => setModal(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ── STATE RESOURCES (MODAL POPUP) ────────────────────────────
function StateResourcesSection() {
  const [states,   setStates]   = useState([])
  const [loading,  setLoading]  = useState(true)
  const [search,   setSearch]   = useState('')
  const [filter,   setFilter]   = useState('all') // all | with-data
  const [modal,    setModal]    = useState(null)  // state object or null

  useEffect(() => {
    supabase.from('resources_states').select('*').eq('published',true).order('state_code',{ascending:true})
      .then(({ data }) => { setStates(data||[]); setLoading(false) })
  }, [])

  // Close modal with Escape key
  useEffect(() => {
    if (!modal) return
    function onKey(e) { if (e.key === 'Escape') setModal(null) }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [modal])

  const filtered = states.filter(s => {
    const matchSearch = !search || s.state_name.toLowerCase().includes(search.toLowerCase()) || s.state_code.toLowerCase().includes(search.toLowerCase())
    if (!matchSearch) return false
    if (filter === 'with-data') return stateHasData(s)
    return true
  })

  const withDataCount = states.filter(stateHasData).length

  // Open a clean print window with this state's info
  function printState(s) {
    const fields = STATE_FIELDS
      .filter(f => s[f.key] && String(s[f.key]).trim())
      .map(f => `<div class="row"><div class="lbl">${f.label}</div><div class="val">${String(s[f.key]).replace(/</g,'&lt;').replace(/\n/g,'<br>')}</div></div>`)
      .join('')

    const html = `<!DOCTYPE html><html><head><title>${s.state_name} — Notary Resources</title><style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:Georgia,serif;background:#fff;color:#151715;padding:40px;line-height:1.6;}
      .header{border-bottom:3px solid #4D4E8D;padding-bottom:14px;margin-bottom:24px;}
      .co{font-size:11px;letter-spacing:0.18em;color:#41427a;text-transform:uppercase;}
      h1{font-size:30px;font-weight:700;margin-top:6px;color:#151715;}
      .state-code{display:inline-block;background:#151715;color:#4D4E8D;padding:4px 12px;border-radius:6px;font-size:13px;font-weight:700;margin-right:10px;}
      .row{display:flex;gap:14px;padding:12px 0;border-bottom:1px solid #E2E4E7;}
      .lbl{min-width:200px;font-weight:700;color:#5C6065;font-size:13px;}
      .val{flex:1;color:#151715;font-size:14px;}
      .url{margin:14px 0 24px;padding:12px;background:#F5F6F7;border-radius:8px;font-size:13px;}
      .url a{color:#41427a;text-decoration:none;word-break:break-all;}
      .footer{margin-top:30px;padding-top:14px;border-top:1px solid #E2E4E7;font-size:11px;color:#A2A6AA;text-align:center;}
      @media print{body{padding:24px;}@page{margin:0.4in;}}
    </style></head><body>
      <div class="header">
        <div class="co">Notary Signing Vault, LLC. · DBA Nationwide Notary Professionals Network</div>
        <h1><span class="state-code">${s.state_code}</span>${s.state_name} — Notary Resources</h1>
      </div>
      ${s.url ? `<div class="url">🔗 State Commission Website: <a href="${s.url}">${s.url}</a></div>` : ''}
      ${fields || '<div style="color:#A2A6AA;padding:20px;text-align:center;">No regulation details on file yet for this state.</div>'}
      <div style="margin-top:24px;padding:14px;background:#EEF0F8;border:1px solid #F0D78A;border-radius:8px;font-size:11px;color:#41427a;line-height:1.5;font-style:italic;">ℹ️ <strong>Disclaimer:</strong> The information provided is for informational and reference purposes only. Always verify accuracy against the official State Commission Website for the most current information.</div>
      <div class="footer">Printed ${new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})} · notarysigningvault.com</div>
      <script>window.onload=function(){window.print()}<\/script>
    </body></html>`
    const w = window.open('', '_blank')
    w.document.write(html)
    w.document.close()
  }

  if (loading) return <div style={{ textAlign:'center', padding:40, color:'#A2A6AA', fontSize:13 }}>Loading...</div>

  if (states.length===0) return (
    <div className="res-section">
      <div className="res-section-header"><span className="res-section-title">🗺️ State Notary Resources</span></div>
      <div className="res-empty"><div className="res-empty-icon">🗺️</div><div className="res-empty-text">Coming soon!!</div></div>
    </div>
  )

  return (
    <>
      <div className="res-section">
        <div className="res-section-header">
          <span className="res-section-title">🗺️ State Notary Resources</span>
          <span style={{ fontSize:11, color:'#A2A6AA' }}>{states.length} states · {withDataCount} with detailed regulations</span>
        </div>

        <div style={{ padding:'14px 16px', borderBottom:'1px solid #E2E4E7' }}>
          <input className="res-search" placeholder="Search by state..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>

        <div className="res-filter-row">
          <button type="button" className={`res-filter-btn${filter==='all'?' active':''}`} onClick={() => setFilter('all')}>All States ({states.length})</button>
          <button type="button" className={`res-filter-btn${filter==='with-data'?' active':''}`} onClick={() => setFilter('with-data')}>📋 With Regulations ({withDataCount})</button>
        </div>

        {filtered.length === 0 ? (
          <div className="res-empty"><div className="res-empty-icon">🔍</div><div className="res-empty-text">No states match!!</div></div>
        ) : (
          <div className="res-state-grid">
            {filtered.map(s => {
              const hasData = stateHasData(s)
              const fieldCount = STATE_FIELDS.filter(f => s[f.key] && String(s[f.key]).trim()).length

              return (
                <div
                  key={s.state_code}
                  className={`res-state-card${hasData?' has-data':''}`}
                  onClick={() => hasData ? setModal(s) : (s.url && window.open(s.url, '_blank'))}
                  title={hasData ? `View ${s.state_name} regulations` : (s.url ? `Visit ${s.state_name} commission site` : '')}
                >
                  <div className="res-state-card-head">
                    <div className="res-state-code">{s.state_code}</div>
                    <div className="res-state-name">{s.state_name}</div>
                    {hasData
                      ? <span className="res-state-chip">📋 {fieldCount}</span>
                      : (s.url && <span style={{ fontSize:11, color:'#41427a' }}>🔗</span>)
                    }
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

      {/* STATE DETAIL MODAL */}
      {modal && (
        <div className="state-modal-overlay" onClick={() => setModal(null)} role="dialog" aria-modal="true" aria-labelledby="state-modal-name">
          <div className="state-modal" onClick={e => e.stopPropagation()}>
            <div className="state-modal-head">
              <div className="state-modal-code">{modal.state_code}</div>
              <div className="state-modal-title">
                <div id="state-modal-name" className="state-modal-name">{modal.state_name}</div>
                <div className="state-modal-sub">NOTARY STATE REGULATIONS & RESOURCES</div>
              </div>
              <button className="state-modal-close" onClick={() => setModal(null)} aria-label="Close">✕</button>
            </div>

            <div className="state-modal-body">
              {STATE_FIELDS.filter(f => modal[f.key] && String(modal[f.key]).trim()).length === 0 ? (
                <div className="state-modal-empty">
                  <div style={{ fontSize:36, marginBottom:10 }}>📋</div>
                  <div>No detailed regulations on file yet.</div>
                  <div style={{ fontSize:11, color:'#A2A6AA', marginTop:6 }}>Check the commission website for the latest info!!</div>
                </div>
              ) : (
                STATE_FIELDS
                  .filter(f => modal[f.key] && String(modal[f.key]).trim())
                  .map(f => (
                    <div key={f.key} className="state-modal-field">
                      <div className="state-modal-field-label">{f.label}</div>
                      <div className="state-modal-field-value">{modal[f.key]}</div>
                    </div>
                  ))
              )}
            </div>

            <div className="state-modal-disclaimer">
              <span className="state-modal-disclaimer-icon">ℹ️</span>
              <span><em>The information provided in State Resources is for informational and reference purposes only. Always verify accuracy against the official State Commission Website for the most current information.</em></span>
            </div>

            <div className="state-modal-foot">
              {modal.url && (
                <a href={modal.url} target="_blank" rel="noreferrer" className="res-state-link-btn">
                  🔗 State Site
                </a>
              )}
              <button type="button" className="res-state-link-btn outline" onClick={() => printState(modal)}>
                🖨️ Print / Save PDF
              </button>
              <button type="button" className="res-state-link-btn" style={{ background:'#5C6065' }} onClick={() => setModal(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

// ── DOCUMENT LIBRARY ──────────────────────────────────────────
function DocumentLibrarySection() {
  const [docs,    setDocs]    = useState([])
  const [loading, setLoading] = useState(true)
  const [cat,     setCat]     = useState('All')
  const [search,  setSearch]  = useState('')

  useEffect(() => {
    supabase.from('resources_documents').select('*').eq('published',true)
      .order('sort_order',{ascending:true}).order('created_at',{ascending:false})
      .then(({ data }) => { setDocs(data||[]); setLoading(false) })
  }, [])

  const filtered = docs.filter(d => {
    const matchCat    = cat==='All' || d.category===cat
    const matchSearch = !search || d.name.toLowerCase().includes(search.toLowerCase()) || (d.description||'').toLowerCase().includes(search.toLowerCase())
    return matchCat && matchSearch
  })

  if (loading) return <div style={{ textAlign:'center', padding:40, color:'#A2A6AA', fontSize:13 }}>Loading...</div>

  return (
    <div className="res-section">
      <div className="res-section-header">
        <span className="res-section-title">📂 Document Library</span>
        <span style={{ fontSize:11, color:'#A2A6AA' }}>{docs.length} document{docs.length!==1?'s':''}</span>
      </div>
      <div style={{ padding:'14px 16px', borderBottom:'1px solid #E2E4E7' }}>
        <input className="res-search" placeholder="Search documents..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="res-filter-row">
        {DOC_CATEGORIES.map(c => (
          <button key={c} type="button" className={`res-filter-btn${cat===c?' active':''}`} onClick={() => setCat(c)}>{c}</button>
        ))}
      </div>
      {filtered.length===0 ? (
        <div className="res-empty"><div className="res-empty-icon">📂</div><div className="res-empty-text">{docs.length===0?'Document library coming soon!!':'No documents found!!'}</div></div>
      ) : (
        <div className="res-doc-grid">
          {filtered.map(d => (
            <div key={d.id} className="res-doc-card">
              <div className="res-doc-card-top">
                <div className="res-doc-icon">{d.file_type?.includes('pdf')?'📕':d.file_type?.includes('image')?'🖼️':'📄'}</div>
                <div><div className="res-doc-name">{d.name}</div>{d.description&&<div className="res-doc-desc">{d.description}</div>}</div>
              </div>
              <div className="res-doc-card-bottom">
                <span className="res-doc-cat">{d.category||'General'}</span>
                <a href={d.file_url} target="_blank" rel="noreferrer" className="res-doc-btn">⬇️ View / Download</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ── MAIN ──────────────────────────────────────────────────────
export default function NotaryResources() {
  const [tab, setTab] = useState('manual')
  return (
    <>
      <style>{RES_STYLES}</style>
      <div className="res-hero">
        <h1 className="res-hero-title">📚 Notary Resources</h1>
        <p className="res-hero-sub">Everything you need to grow as an NSV notary — training materials, glossary of terms, state commission resources, and document examples!!</p>
      </div>
      <div className="res-tabs">
        <button className={`res-tab${tab==='manual'?' active':''}`} onClick={() => setTab('manual')}>📋 Training Manual</button>
        <button className={`res-tab${tab==='glossary'?' active':''}`} onClick={() => setTab('glossary')}>📖 Glossary</button>
        <button className={`res-tab${tab==='states'?' active':''}`} onClick={() => setTab('states')}>🗺️ State Resources</button>
        <button className={`res-tab${tab==='library'?' active':''}`} onClick={() => setTab('library')}>📂 Document Library</button>
      </div>
      {tab==='manual'   && <TrainingManualRedirect />}
      {tab==='glossary' && <GlossarySection />}
      {tab==='states'   && <StateResourcesSection />}
      {tab==='library'  && <DocumentLibrarySection />}
    </>
  )
}
